import { currentCurrency } from '@/config/billing/currencies';

/**
 * Format currency by country
 */
export const formatCurrency = value => currentCurrency(parseFloat(value || 0, 0)).format();
